import React, { useState, useEffect } from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import apis from '../services';
import { showApiErrors } from '../utils';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgot = async (e) => {
    e.preventDefault();
    try {
      const res = await apis.authRequestOtp({ email });
      console.log(res, "---");
      setLoading(true);
      navigate('/verification', { state: { email }, replace: true });
    } catch (error) {
      showApiErrors(error, 'Something went wrong, please try again');
    }
  };

  return (
    <div className="login-background">
      {/* Header Start */}
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp-lookna">Lookna</span>
            <br /><br />
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
          </h2>
        </div>
        <div className="details-borders"></div>
      </div>
      {/* Header End */}

      <div style={{ height: "60px" }}></div>
      <div className="login-box">
        <h2 className="login-title" style={{ textAlign: "center" }}>FORGOT PASSWORD</h2>
        <form className="login-form" onSubmit={handleForgot}>
          <label className="input-label">Email</label>
          <div className="input-group">
            <input
              type="email"
              placeholder="Please Enter You Email"
              className="input-field"
              required
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <FaEnvelope className="input-icon" />
          </div>
          <button
            className="login-btn"
            type="submit"
            disabled={loading}
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              marginTop: "15px"
            }}
          >
            {loading ? 'Loading...' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;